angular.module('graph').config([
    '$locationProvider', function($provider) {
        $provider.html5Mode({
            enabled     : true,
            requireBase : false,
            rewriteLinks: false
        });
    }
]);

angular.module('graph').filter('yelmatch', [
    function() {
        return function(input, pattern) {
            var regexp = new RegExp('(' + pattern + ')', 'ig');

            return input.replace(
                regexp, '<span class="yellow">$1</span>'
            );
        };
    }
]);

angular.module('graph').service('goto-search', ['$location', '$timeout', function($location, $timeout) {
    this.watch = function($scope, entry, input) {
        var timer;

        $scope.$watch(function() {
            return $scope[input];
        }, function (nval, oval) {
            if (nval !== oval) {
                if (timer) $timeout.cancel(timer);

                timer = $timeout(function() {
                    window.location.href = '/search/' + entry + '?q=' + nval;
                    // $location.path();
                    // $location.replace();
                }, 500);
            }
        });
    };
}])

angular.module('graph').controller('search-ctrl', [
    '$scope', '$http', '$location', '$timeout', 'fxScrollFactory', function($scope, $http, $location, $timeout, $scroll) {
        var t, memory = $location.search().q;

        $scope.entry = $location.path().replace('/search/', '');

        $scope.nodes = [];

        $scope.wait  = 0;

        $scope.form  = {
            q       : memory,
            page    : 0,
            limit   : 10
        };

        $scope.switch = function (entry) {
            $scope.entry     = entry;

            $scope.nodes     = [];
            $scope.form.page = 0;

            $location.path('/search/' + entry);

            $scroll.renew('search');

            if ($scope.form.q && $scope.form.q.length > 0)
                $scope.search();

        };

        $scope.search = function(next) {
            ++$scope.form.page;

            $http.get('/xhr/search/' + $scope.entry, {
                params: $scope.form
            }).then(function(response) {
                if (response.data.state === 0 && response.data.data.length > 0) {
                    $scope.nodes = $scope.nodes.concat(
                        response.data.data
                    );

                    $scope.wait = 0;

                    if (next) next();
                }
            });
        };

        $scope.$watch(function() {
            return $scope.form.q;
        }, function (nval, oval) {
            if (nval !== oval) {
                $scope.wait = 1;
                // if (nval !==)
                if (t) $timeout.cancel(t);

                t = $timeout(function() {
                    $scope.nodes     = [];
                    $scope.form.page = 0;

                    if (nval.length > 0) {
                        $scope.search();
                    } else {
                        $scope.wait = 0;
                    }

                    $location.search(
                        'q', $scope.form.q
                    );
                }, 500);
            }
        });

        if ($scope.form.q && $scope.form.q.length > 0)
            $scope.search();
    }
]);

angular.module('graph').controller('ph-drop-search', [
    '$scope', 'ph-core', 'ph-route-params-service', '$rootScope', 'ph-touch-service', '$timeout',
    function ($scope, $core, $route, $root, $phtouch, $timeout) {
        $scope.$data = {
            entries: [],
            count: 0,
            active: 0
        };

        $scope.$request = {
            "get": {
                search: function () {
                    $scope.$data.count = 0;

                    if ($scope.$data.active === 0) {
                        $scope.$data.active = 1;
                    }

                    $core.get('/xhr/search?q=' + $scope.$filters.q)
                        .then(function ($response) {

                            if ($response.data.state === 0) {
                                $scope.$data.entries = $response.data.data
                            }

                            for (var entry in $response.data.data) {
                                $scope.$data.count += $response.data.data[entry].length;
                            }
                        });
                }
            }
        };

        $scope.$filters = {
            q: '',
            timer: null
        };

        var $module = 'ph-drop-search';

        $phtouch.$watch($scope, $module, function () {
            $phtouch.$touch($module, function () {
                $scope.$request.get.search();
            });
        });

        $scope.$watch(function () {
            return $scope.$filters.q;
        }, function (nval, oval) {
            if (nval === '')
                $scope.$data.active = 0;
            if (oval !== nval && nval !== '') {
                $timeout.cancel($scope.$filters.timer);
                $scope.$filters.timer = $timeout(function () {
                    $scope.$request.get.search();
                }, 500);
            }
        });
    }
]);
